var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarityDesignLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:design-line",
    clipPath: "url(#clip0_3608_9611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.75 59.4844V92.2502H63.5158L56.6825 85.4169H37.5833V66.3177L30.75 59.4844Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M119.139 110.324L109.333 100.381V109.333H13.6664V95.1539H20.4997V89.6872H13.6664V66.9664H20.4997V61.4997H13.6664V39.633H20.4997V34.1664H13.6664V15.0672L68.1281 69.2214V59.5864L12.6756 4.40719C12.1977 3.92534 11.5871 3.59672 10.9217 3.46323C10.2563 3.32975 9.56627 3.39743 8.9395 3.65767C8.31274 3.91791 7.77767 4.3589 7.40251 4.92443C7.02736 5.48995 6.82912 6.15439 6.83307 6.83302V112.75C6.83307 113.656 7.19303 114.525 7.83378 115.166C8.47453 115.806 9.34358 116.166 10.2497 116.166H116.713C117.392 116.17 118.056 115.972 118.622 115.597C119.187 115.222 119.628 114.687 119.888 114.06C120.149 113.433 120.216 112.743 120.083 112.078C119.949 111.412 119.621 110.802 119.139 110.324Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.0003 102.499H95.667C97.4793 102.499 99.2174 101.779 100.499 100.498C101.78 99.2164 102.5 97.4783 102.5 95.666V29.7243L94.642 15.2718C94.0342 14.2189 93.1566 13.3471 92.0995 12.7465C91.0424 12.1459 89.8443 11.8382 88.6287 11.8552C87.3855 11.865 86.1686 12.2138 85.1089 12.8641C84.0493 13.5143 83.1872 14.4413 82.6153 15.5452L75.167 29.7927V95.666C75.167 97.4783 75.8869 99.2164 77.1684 100.498C78.4499 101.779 80.188 102.499 82.0003 102.499ZM82.0003 31.4327L88.6287 18.5518L95.667 31.4668V81.9993H82.0003V31.4327ZM82.0003 87.5685H95.667V95.9052H82.0003V87.5685Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3608_9611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityDesignLine);
export default __webpack_public_path__ + "static/media/clarity_design-line.8386e3b3b439e9f60834dd83fbbd7772.svg";
export { ForwardRef as ReactComponent };